/* eslint-disable react-refresh/only-export-components */
import { takeLatest, put, call } from "redux-saga/effects"
import {
  CategoryAssociationDTO,
  DeleteCategoryAssociationDTO,
  UpdateCategoryAssociationDTO,
  downloadCSVFile,
  downloadCSVFileFailed,
  downloadCSVFileSuccess,
  getBankList,
  getBankListFailed,
  getBankListSuccess,
  getCategoryList,
  getCategoryListFailed,
  getCategoryListPayloadType,
  getCategoryListSuccess,
  getPaymentMethods,
  getPaymentMethodsFailed,
  getPaymentMethodsSuccess,
  getProcessSchedule,
  getProcessScheduleFailed,
  getProcessScheduleSuccess,
  cancelProcessScheduleFailed,
  cancelProcessScheduleSuccess,
  getSubCategoryList,
  getSubCategoryList1,
  getSubCategoryList1Success,
  getSubCategoryListSuccess,
  getTransactionList,
  getTransactionListFailed,
  getTransactionListPayloadType,
  getTransactionListSuccess,
  initiateProcessSchedule,
  submitCategoryAssociationFailure,
  submitCategoryAssociationRequest,
  submitCategoryAssociationSuccess,
  submitDeleteCategoryAssociationFailure,
  submitDeleteCategoryAssociationRequest,
  submitDeleteCategoryAssociationSuccess,
  submitUpdateCategoryAssociationRequest,
  uploadCSVFile,
  uploadCSVFileFailed,
  uploadCSVFilePayloadType,
  uploadCSVFileSuccess,
  cancelProcessSchedule,
  reinitiateProcessSchedule,
  getSearchListSuccess,
  getSearchListFailed,
  getSearchList,
  syncZohoDataSuccess,
  syncZohoDataFailed,
  syncZohoData,
} from "../slices/transactionsSlice"
import {
  cancelSchedule,
  downloadCSVFileService,
  fetchCategoryListService,
  fetchProcessScheduleData,
  fetchSearchListService,
  fetchTransactionListService,
  getBankListService,
  getPaymentMethodsService,
  intiateProcessSchedule,
  reintiateProcessSchedule,
  submitCategoryAssociation,
  submitDeleteCategoryAssociation,
  submitUpdateCategoryAssociation,
  syncZohoDataService,
  uploadCSVFileService,
} from "../services/transactionsService"
import {
  Bank,
  Category,
  ProcessSchedule,
  SearchList,
  Transaction,
} from "../models/transactions.model"
import { showToast } from "../slices/toastSlice"
import { PayloadAction } from "@reduxjs/toolkit"
import { ApiResponse } from "../models/api-response.model"

export function* getTransactionListSaga(action: getTransactionListPayloadType) {
  try {
    const { data } = yield call(fetchTransactionListService, action)
    yield put(
      getTransactionListSuccess({
        transactionList:
          data?.data?.transactions?.map((transaction: any) => ({
            ...new Transaction(transaction),
          })) || [],
        totalRowCount: data?.pagination?.total || 0,
      }),
    )
  } catch (err) {
    yield put(getTransactionListFailed())
  }
}

export function* uploadCSVFileSaga(action: uploadCSVFilePayloadType) {
  try {
    yield call(uploadCSVFileService, action)
    yield put(showToast({ toastType: "success", msg: "Successfully Uploaded" }))
    yield put(uploadCSVFileSuccess())
  } catch (err) {
    yield put(uploadCSVFileFailed())
  }
}

export function* downloadCSVFileSaga(action: getTransactionListPayloadType) {
  try {
    const { data } = yield call(downloadCSVFileService, action)
    const url = URL.createObjectURL(data)
    const a = document.createElement("a")
    a.href = url
    a.download = `${Date.now()}-transactions.xls`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    yield put(
      showToast({ toastType: "success", msg: "Successfully Downloaded" }),
    )
    yield put(downloadCSVFileSuccess())
  } catch (err: any) {
    yield put(downloadCSVFileFailed())
  }
}

export function* getBankListSaga() {
  try {
    const { data } = yield call(getBankListService)
    yield put(
      getBankListSuccess({
        bankList: data?.data?.map((bank: any) => ({
          ...new Bank(bank),
        })),
      }),
    )
  } catch (err) {
    yield put(getBankListFailed())
  }
}

export function* getPaymentMethodsSaga() {
  try {
    const { data } = yield call(getPaymentMethodsService)
    yield put(
      getPaymentMethodsSuccess({
        paymentMethods: data?.data?.map(
          (method: { id: string; name: string }) => {
            return { key: method?.id, value: method?.name }
          },
        ),
      }),
    )
  } catch (err) {
    yield put(getPaymentMethodsFailed())
  }
}

export function* getProcessScheduleSaga() {
  try {
    const { data } = yield call(fetchProcessScheduleData)
    yield put(
      getProcessScheduleSuccess({
        processScheduleData: { ...new ProcessSchedule(data) },
      }),
    )
  } catch (err) {
    yield put(getProcessScheduleFailed())
  }
}

export function* initiateProcessScheduleSaga() {
  try {
    const { data } = yield call(intiateProcessSchedule)
    yield put(
      showToast({
        toastType: "success",
        msg: data.message,
      }),
    )
    yield put(
      getProcessScheduleSuccess({
        processScheduleData: { ...new ProcessSchedule(data) },
      }),
    )
  } catch (err) {
    yield put(getProcessScheduleFailed())
  }
}
export function* cancelProcessScheduleSaga() {
  try {
    const { data } = yield call(cancelSchedule)
    yield put(
      showToast({
        toastType: "success",
        msg: data.message,
      }),
    )
    yield put(
      cancelProcessScheduleSuccess({
        processScheduleData: { ...new ProcessSchedule(data) },
      }),
    )
  } catch (err) {
    yield put(cancelProcessScheduleFailed())
  }
}
export function* reinititeProcessScheduleSaga() {
  try {
    const { data } = yield call(reintiateProcessSchedule)
    yield put(
      showToast({
        toastType: "success",
        msg: data.message,
      }),
    )
    yield put(
      getProcessScheduleSuccess({
        processScheduleData: { ...new ProcessSchedule(data) },
      }),
    )
  } catch (err) {
    yield put(getProcessScheduleFailed())
  }
}

export function* getCategoryListSaga(action: getCategoryListPayloadType) {
  try {
    const { data } = yield call(fetchCategoryListService, action)
    yield put(
      getCategoryListSuccess({
        categoryList: data?.data?.map((category: any) => ({
          ...new Category(category),
        })),
      }),
    )
  } catch (err) {
    yield put(getCategoryListFailed())
  }
}
export function* getSubCategoryListSaga(action: getCategoryListPayloadType) {
  try {
    const { data } = yield call(fetchCategoryListService, action)
    yield put(
      getSubCategoryListSuccess({
        categoryList: data?.data?.map((category: any) => ({
          ...new Category(category),
        })),
      }),
    )
  } catch (err) {
    yield put(getCategoryListFailed())
  }
}
export function* getSubCategory1ListSaga(action: getCategoryListPayloadType) {
  try {
    const { data } = yield call(fetchCategoryListService, action)
    yield put(
      getSubCategoryList1Success({
        categoryList: data?.data?.map((category: any) => ({
          ...new Category(category),
        })),
      }),
    )
  } catch (err) {
    yield put(getCategoryListFailed())
  }
}

export function* CategoryAssociationSaga(
  action: PayloadAction<CategoryAssociationDTO>,
) {
  try {
    const response: ApiResponse<Record<string, never>> = yield call(
      submitCategoryAssociation,
      action.payload,
    )
    yield put(submitCategoryAssociationSuccess())
    yield put(
      showToast({
        toastType: response.success ? "success" : "info",
        msg: response.message,
      }),
    )
  } catch (error) {
    yield put(submitCategoryAssociationFailure())
  }
}

export function* UpdateCategoryAssociationSaga(
  action: PayloadAction<UpdateCategoryAssociationDTO>,
) {
  try {
    const response: ApiResponse<Record<string, never>> = yield call(
      submitUpdateCategoryAssociation,
      action.payload,
    )
    yield put(submitCategoryAssociationSuccess())
    yield put(
      showToast({
        toastType: response.success ? "success" : "info",
        msg: response.message,
      }),
    )
  } catch (error) {
    yield put(submitCategoryAssociationFailure())
  }
}
export function* DeleteCategoryAssociationSaga(
  action: PayloadAction<DeleteCategoryAssociationDTO>,
) {
  try {
    const response: ApiResponse<Record<string, never>> = yield call(
      submitDeleteCategoryAssociation,
      action.payload,
    )
    yield put(submitDeleteCategoryAssociationSuccess())
    yield put(
      showToast({
        toastType: response.success ? "success" : "info",
        msg: response.message,
      }),
    )
  } catch (error) {
    yield put(submitDeleteCategoryAssociationFailure())
  }
}

export function* getFilterListSaga() {
  try {
    const { data } = yield call(fetchSearchListService)
    yield put(
      getSearchListSuccess({
        searchList: data?.data?.map((item: any) => ({
          ...new SearchList(item),
        })),
      }),
    )
  } catch (err) {
    yield put(getSearchListFailed())
  }
}

export function* syncZohoDataSaga(action: PayloadAction<string>) {
  try {
    yield call(syncZohoDataService, action.payload)
    yield put(
      showToast({ toastType: "success", msg: "Zoho data synced successfully" }),
    )
    yield put(syncZohoDataSuccess())
  } catch (err) {
    yield put(syncZohoDataFailed())
    yield put(showToast({ toastType: "error", msg: "Zoho data sync failed" }))
  }
}

export default function* transactionSaga() {
  yield takeLatest(getTransactionList, getTransactionListSaga)
  yield takeLatest(uploadCSVFile, uploadCSVFileSaga)
  yield takeLatest(downloadCSVFile, downloadCSVFileSaga)
  yield takeLatest(getBankList, getBankListSaga)
  yield takeLatest(getPaymentMethods, getPaymentMethodsSaga)
  yield takeLatest(getProcessSchedule, getProcessScheduleSaga)
  yield takeLatest(initiateProcessSchedule, initiateProcessScheduleSaga)
  yield takeLatest(reinitiateProcessSchedule, reinititeProcessScheduleSaga)
  yield takeLatest(cancelProcessSchedule, cancelProcessScheduleSaga)
  yield takeLatest(getCategoryList, getCategoryListSaga)
  yield takeLatest(getSubCategoryList, getSubCategoryListSaga)
  yield takeLatest(getSubCategoryList1, getSubCategory1ListSaga)
  yield takeLatest(submitCategoryAssociationRequest, CategoryAssociationSaga)
  yield takeLatest(
    submitDeleteCategoryAssociationRequest,
    DeleteCategoryAssociationSaga,
  )
  yield takeLatest(
    submitUpdateCategoryAssociationRequest,
    UpdateCategoryAssociationSaga,
  )
  yield takeLatest(getSearchList, getFilterListSaga)
  yield takeLatest(syncZohoData, syncZohoDataSaga)
}
